<template>
  <v-card dark class="edit experience-organization">
    <v-card-title primary-title>
      <v-avatar class="elevation-0 mr-3">
        <img src="/img/missing/logos/organizations/original.png" />
      </v-avatar>
      <div class="headline" v-if="experienceOrganization.name">
        Create {{ experienceOrganization.name }}
      </div>
      <div class="headline" v-else>
        Create Experience Organization
      </div>
    </v-card-title>

    <v-alert error transition="scale-transition" :value="experienceOrganization.errors.length">
      <ul>
        <li v-for="(message, i) in experienceOrganization.errors" :key="`error-${i}`">
          {{ message }}
        </li>
      </ul>
    </v-alert>

    <v-card-text>
      <v-form v-model="valid" @submit.prevent="submit" ref="form">
        <v-text-field label="Name" v-model="experienceOrganization.name" :rules="rules.name" />

        <v-autocomplete
          label="Industry"
          v-if="industries.length > 0"
          v-model="experienceOrganization.industry"
          :items="industries"
          :rules="rules.industry"
          required
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn flat @click="$emit('cancel')" color="grey">
        Cancel
      </v-btn>
      <v-btn :disabled="!valid" @click="submit" color="primary">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// Data
import industries from '@/data/industries'

// Vue Component
export default {
  name: 'ExperienceOrganizationCreate',

  data() {
    return {
      experienceOrganization: { name: '', industry: '', errors: [] },
      // Validations
      valid: true,
      rules: {
        name: [v => !!v || 'must be specified'],
        industry: [v => (!!v && industries.some(i => i === v)) || 'must be specified'],
      },
      // Data
      industries,
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('admin/experience_organizations/create', this.experienceOrganization)
          .then(
            data => {
              this.$store.dispatch('snackbarSuccess', 'Experience Organzation Created')
              this.$router.push(`/experience_organizations/${data.id}`)
            },
            errors => {
              Object.assign(this.experienceOrganization, errors)
              this.$store.dispatch('snackbarError', 'Could not create Experience Organzation')
            }
          )
      }
    },
  },
}
</script>
